import type { Cohort } from '@efdigital/ll-addon-data/types/xceed/cohort';
import { findCohortWithContent } from '@efdigital/ll-admin-v2/data/builders/xceed/cohorts';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramModel } from '../program.ts';

export type ParamsCohortId = {
  cohort_id: string;
};

export type ProgramsProgramCohortModel = ProgramsProgramModel &
  ParamsCohortId & {
    cohort: Cohort;
  };

export default class ProgramsProgramCohortRoute extends Route<ProgramsProgramCohortModel> {
  @service declare store: Store;

  async model(params: ParamsCohortId) {
    return {
      ...(this.modelFor('programs.program') as ProgramsProgramModel),
      ...params,
      cohort: (
        await this.store.request(findCohortWithContent(params.cohort_id))
      ).content.data,
    };
  }
}
